export enum ComponentNames {
  COMPETITORTABLE = "COMPETITORTABLE",
  DTVMARQUEE = "DTVMARQUEE",
  DTVCAROUSEL = "DTVCAROUSEL",
  ROTATINGMARQUEE = "ROTATINGMARQUEE",
  VIDEOMARQUEE = "VIDEOMARQUEE",
  IMAGEMARQUEE = "IMAGEMARQUEE",
  VIDEOPOPUPMARQUEE = "VIDEOPOPUPMARQUEE",
  VIDEOCAROUSEL = "VIDEOCAROUSEL",
  CANVAS = "CANVAS",
  CHANNEL_LINEUP = "CHANNEL_LINEUP",
  CHANNEL_COMPARISON_TOOL = "CHANNEL_COMPARISON_TOOL",
  CHANNEL_LISTING_PAGE = "CHANNEL_LISTING_PAGE",
  SATELLITE_CHANNEL_LISTING_PAGE = "SATELLITE_CHANNEL_LISTING_PAGE",
  HERO_PANEL = "HEROPANEL",
  HERO_PANEL_V3 = "HEROPANELV3",
  ALERT_BANNER = "ALERTBANNER",
  CARD_GRID_LIST = "CARDGRIDLIST",
  FAQ = "FAQ",
  FORM_BUILDER = "FORMBUILDER",
  FORM_BUILDERV2 = "FORMBUILDERV2",
  BREADCRUMBS = "BREADCRUMBS",
  BREADCRUMBSV2 = "BREADCRUMBSV2",
  GVP_PANEL = "GVPPANEL",
  TABLE = "TABLE",
  TIMEOUTMODAL = "TIMEOUTMODAL",
  CAROUSEL = "CAROUSEL",
  PARALLAXCONTAINER = "PARALLAXCONTAINER",
  RECOGNIZED_LANDER = "RECOGNIZED_LANDER",
  QUIZ = "QUIZ",
  QUIZV2 = "QUIZV2",
  EMAILCAPTUREV2 = "EMAILCAPTUREV2",
  QUIZONCANVAS = "QUIZONCANVAS",
  IFRAME = "IFRAME",
  TWITTER_FEED = "TWITTER_FEED",
  CHANNELS_BOARD = "CHANNELSBOARD",
  CHLUP_INTERACTIVE_TOOL = "CHLUPINTERACTIVETOOL",
  TABBING = "TABBING",
  ROWCANVAS = "ROWCANVAS",
  ROWCANVASV2 = "ROWCANVASV2",
  EMAILPOPUPMODAL = "EMAILPOPUPMODAL",
  MOSAIC = "MOSAIC",
  FLOATINGWIDGET = "FLOATINGWIDGET",
  FLOATINGWIDGETV2 = "FLOATINGWIDGETV2",
  // W&C MUI5 Comps
  LONGFORMATCARD = "LONGFORMATCARD",
  CONTENTCARDS = "CONTENTCARDS",
  PAGESECTIONHEADER = "PAGESECTIONHEADER",
  PLANCARD = "PLANCARD",
  INPAGELEGAL = "INPAGELEGAL",
  INTERNALPRODCUTCOMPARISIONCHART = "INTERNALPRODCUTCOMPARISIONCHART",
  DTVHERO = "DTVHERO",
  VERTICALSPACER = "VERTICALSPACER",
  VERTICALVIDEOCAROUSEL= "VERTICALVIDEOCAROUSEL",
  HEADLINE = "HEADLINE",
  LIST_ITEM = "LIST_ITEM",
  FOUR_UP_ICON_LIST = "FOUR_UP_ICON_LIST",
  MESSAGINGBANNER = "MESSAGINGBANNER",
  MESSAGINGCARD = "MESSAGINGCARD",
  EXTERNALSERVICECOMPARISON = "EXTERNALSERVICECOMPARISON",
  DTV1UP2UPMEDIA = "DTV1UP2UPMEDIA",
  DTVIFRAME = "DTVIFRAME",
  DTVLINKFARM = "DTVLINKFARM",
  DTVAGNOSTICPLANCARDS = "AGNOSTICPLANCARDS",
  INSIDERARTICLE = "INSIDERARTICLE",
  REFERENCECOMPONENT = "REFERENCECOMPONENT",
  CHANNELLOGOCAROUSAL = "CHANNELLOGOCAROUSAL",
  DTVFIRSTNAME = "DTVFIRSTNAME",
  DTVTHREEUP = "DTVTHREEUP",
  LINKFOREST = "LINKFOREST",
  PACKAGECOMPARISONCALCULATOR = "PACKAGECOMPARISONCALCULATOR",
  LOCALCHANNELSLOOKUPPAGE = "LOCALCHANNELSLOOKUPPAGE",
  DTVFLASH = "DTVFLASH",
  PAGETHEME = "PAGETHEME",
  PAGEBACKGROUNDS = "PAGEBACKGROUNDS",
  PAGEPROPERTY = "PAGEPROPERTY",
  FINDRETAILER = "FINDRETAILER",
  SEARCHCOMPONENT = "SEARCHCOMPONENT",
  MARKETINGBANNER = "MARKETINGBANNER",
  SHOWCAROUSAL = "SHOWCAROUSAL",
  OFFERCARDS = "OFFERCARDS",
  SEARCHWATCHNOW = "SEARCHWATCHNOW",
  DTVEXTERNALSCRIPTLOADER = "DTVEXTERNALSCRIPTLOADER",
  DTVMDUHERO = "DTVMDUHERO",
  SEOCONTENT = "SEOCONTENT",
  DTVCOUNTDOWN = "DTVCOUNTDOWN",
  TVPROMISE = "TVPROMISE",
  REVIEWCAROUSEL = "REVIEWCAROUSEL",
  DISHPOINTER = "DISHPOINTER",
  // WAT-10279: enum key kept as EXITMODAL for legacy callsites; the CMS type
  // string is "EXITMODALV2" (the v1 exit modal was retired in this ticket).
  EXITMODAL = "EXITMODALV2",
  MARKETINGAIMODAL = "MARKETINGAIMODAL",
  VIDEOMARQUEECAMPAIGN = "VIDEOMARQUEECAMPAIGN",
  FLAPPYPIGEON = "FLAPPYPIGEON",
  SCROLLTOTOP = "SCROLLTOTOP",
  RSNLOOKUPTOOL = "RSNLOOKUPTOOL",
  RSNFEELOOKUP = "RSNFEELOOKUP",
  EXTERNALSERVICECOMPARISONTABS = "EXTERNALSERVICECOMPARISONTABS",
  OEM = "OEM",
  DTVYOTPOGALLERYWRAPPER = "DTVYOTPOGALLERYWRAPPER",
  INPAGENAV = "INPAGENAV",
  PACKAGECOMPARISON = "PACKAGECOMPARISON",
  CHANNEL_COMPARISON_TOOL_V2 = "CHANNEL_COMPARISON_TOOL_V2",
  CHANNEL_LINEUP_FFP = "CHANNEL_LINEUP_FFP",
  APPDOWNLOADBANNER = "APPDOWNLOADBANNER",
  TOGGLE_PLAN_CARD = "TOGGLE_PLAN_CARD",
  HORIZONTAL_PLAN_CARD = "HORIZONTAL_PLAN_CARD",
  LOCALSONLYMODAL = "LOCALSONLYMODAL",
  GLOBALHEADER = "GLOBALHEADER",
  LOCALRSNTOOL= "LOCALRSNTOOL",
  PLANPORTAL  = "PLANPORTAL",
  YOTPOPACKAGEREVIEWWIDGET="YOTPOPACKAGEREVIEWWIDGET",
  PACKAGECOMPARETOOL = "PACKAGECOMPARETOOL",
  DTVAGENTPACKAGECOMPARETOOL = "DTVAGENTPACKAGECOMPARETOOL",
  CHANNELPACKLINEUP = "CHANNELPACKLINEUP",
  INPAGECHANNELPACKLINEUP = "INPAGECHANNELPACKLINEUP",
  GENREPREVIEWTOOL = "GENREPREVIEWTOOL",
  TABTRAY = "TABTRAY",
  CONSPIRACYBOARD = "CONSPIRACYBOARD",
  EQUIPMENTWIZARD = "EQUIPMENTWIZARD",
  AMBIENTVIDEOMARQUEE= "AMBIENTVIDEOMARQUEE",
  FEATUREDARTICLELIST = "FEATUREDARTICLELIST",
  YOTPOPACKAGERATING="YOTPOPACKAGERATING",
  VIDEOMODALLINK = "VIDEOMODALLINK",
  MEDIA_CARD_IMAGE_1UP_2UP_V2 = "MEDIA_CARD_IMAGE_1UP_2UP_V2",
  REVISITORMODAL = "REVISITORMODAL",
  SITEMAP = "SITEMAP",
  PACKAGECAROUSEL = "PACKAGECAROUSEL",
  FLIPCARDS = "FLIPCARDS",
  GENREPACKDETAILSPANEL = "GENREPACKDETAILSPANEL",
  COMPETITORCOMPARISONTABLEV2 = "COMPETITORCOMPARISONTABLEV2",
  DTVIFRAMEV2 = "DTVIFRAMEV2",
  CONTENTCARDC = "CONTENTCARDC",
  LINKFARM = "LINKFARM",
  GLOBALFOOTER = "GLOBALFOOTER",
  CUSTOMERACQCOMPARETOOL = "CUSTOMERACQCOMPARETOOL",
  SIERRACHAT = "SIERRACHAT",
}

export default ComponentNames;
